var HttpURL = /** @class */ (function () {
    function HttpURL(endpoint, pathBuilderOrPath) {
        this.endpoint = endpoint;
        this.pathBuilderOrPath = pathBuilderOrPath;
    }
    HttpURL.prototype.toString = function (payload) {
        var path = typeof this.pathBuilderOrPath === 'string'
            ? this.pathBuilderOrPath
            : this.pathBuilderOrPath(payload);
        var purePath = path.replace(/^\/+/, '').replace(/\/+/, '/');
        var pureEndpoint = this.endpoint.replace(/\/+$/, '');
        return (pureEndpoint + "/" + purePath).replace(/\/+$/, '');
    };
    return HttpURL;
}());
export { HttpURL };
//# sourceMappingURL=HttpURL.js.map